module.exports = __webpack_public_path__ + "static/img/1-2.df5e4ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/1-2.png
// module id = 7/HQ
// module chunks = 0